export type ALERTS_POLL_EVENTS_TYPE = "ALERTS_POLL_EVENTS";
export type ALERTS_STOP_POLL_EVENTS_TYPE = "ALERTS_STOP_POLL_EVENTS";
export type ALERTS_SET_EVENTS_TYPE = "ALERTS_SET_EVENTS";
export type ALERTS_SET_SORTING_EVENTS_TYPE = "ALERTS_SET_SORTING_EVENTS";
export type ALERTS_SET_SELECTED_CAMERA_TYPE = "ALERTS_SET_SELECTED_CAMERA";
export type ALERTS_SET_CURRENT_CAMERA_TYPE = "ALERTS_SET_CURRENT_CAMERA";
export type ALERTS_SET_ALARM_SCENARIO_TYPE = "ALERTS_SET_ALARM_SCENARIO";
export type ALERT_DO_ACKNOWLEDGE_TYPE = "ALERT_DO_ACKNOWLEDGE";
export type ALERT_ADD_EVENT_CASE_TYPE = 'ALERT_ADD_EVENT_CASE';


export const ALERTS_POLL_EVENTS: ALERTS_POLL_EVENTS_TYPE = 'ALERTS_POLL_EVENTS';
export const ALERTS_STOP_POLL_EVENTS: ALERTS_STOP_POLL_EVENTS_TYPE = 'ALERTS_STOP_POLL_EVENTS';
export const ALERTS_SET_EVENTS: ALERTS_SET_EVENTS_TYPE = 'ALERTS_SET_EVENTS';
export const ALERTS_SET_SORTING_EVENTS: ALERTS_SET_SORTING_EVENTS_TYPE = 'ALERTS_SET_SORTING_EVENTS';
export const ALERTS_SET_SELECTED_CAMERA: ALERTS_SET_SELECTED_CAMERA_TYPE = 'ALERTS_SET_SELECTED_CAMERA';
export const ALERTS_SET_CURRENT_CAMERA: ALERTS_SET_CURRENT_CAMERA_TYPE = 'ALERTS_SET_CURRENT_CAMERA';
export const ALERTS_SET_ALARM_SCENARIO: ALERTS_SET_ALARM_SCENARIO_TYPE = 'ALERTS_SET_ALARM_SCENARIO';

export const ALERT_DO_ACKNOWLEDGE: ALERT_DO_ACKNOWLEDGE_TYPE = 'ALERT_DO_ACKNOWLEDGE';
export const ALERT_ADD_EVENT_CASE: ALERT_ADD_EVENT_CASE_TYPE = 'ALERT_ADD_EVENT_CASE';
